import { Route, Routes } from "react-router-dom";

import App from "./App";
import Contato from "./pages/contato/page";
import Turismo from "./pages/pontos-turisticos/page";
import Servicos from "./pages/servicos/page";
import Sobre from "./pages/sobre-nos/page";

const RoutesApp = () => {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/contato" element={<Contato />} />
      <Route path="/servicos" element={<Servicos />} />
      <Route path="/sobre-nos" element={<Sobre />} />
      <Route path="/pontos-turisticos" element={<Turismo />} />
    </Routes>
  );
};

export default RoutesApp;
